import { useAtom, useSetAtom } from "jotai";
import {
  globalAtom,
  writeSetGlobalJoinedDaoSubdomainsAtom,
  writeSetGlobalMemberSubscriptionIdAtom,
  writeSetGlobalModeAtom,
  writeSetGlobalUserIdAtom,
} from "~/_model/globalAtom";

export const useGlobalStore = () => {
  const [global, setGlobal] = useAtom(globalAtom);

  const setGlobalJoinedDaoSubdomains = useSetAtom(
    writeSetGlobalJoinedDaoSubdomainsAtom,
  );
  const setGlobalMemberSubscriptionId = useSetAtom(
    writeSetGlobalMemberSubscriptionIdAtom,
  );
  const setGlobalMode = useSetAtom(writeSetGlobalModeAtom);
  const setGlobalUserId = useSetAtom(writeSetGlobalUserIdAtom);

  return {
    global,
    setGlobal,
    setGlobalJoinedDaoSubdomains,
    setGlobalMemberSubscriptionId,
    setGlobalMode,
    setGlobalUserId,
  };
};
